import { GridHelper } from 'components/Grids/GridHelper';
import {
  GeneralCellRenderer,
  NumberCellRenderer,
  BatchActionsCellRenderer
} from 'components/Grids/CellRenderers';

export default class BatchesColumnDefinitions {
  static createColDefs() {
    const columnDefs = [
      {
        headerName: 'Batch ID',
        field: 'batchId',
        cellRendererFramework: GeneralCellRenderer,
        minWidth: 70
      },
      {
        headerName: 'Upload Date',
        field: 'dateUploaded',
        cellRendererFramework: GeneralCellRenderer,
        valueGetter: ({
          data: { dateUploaded }
        }) => GridHelper.dateFormatter(dateUploaded, 'MMM DD, YYYY HH:mm:ss'),
        minWidth: 95,
        width: 145,
        filter: 'text',
        filterParams: { apply: true }
      },
      {
        headerName: 'Status',
        field: 'statusString',
        cellRendererFramework: GeneralCellRenderer,
        minWidth: 100,
        width: 150,
        filter: 'text',
        filterParams: { apply: true }
      },
      {
        headerName: 'Cover Sheet?',
        field: 'coverSheetJson',
        cellClass: 'center-aligned',
        valueGetter: ({
          data: { coverSheetJson }
        }) => (coverSheetJson ? 'Yes' : 'No'),
        minWidth: 100,
        width: 100,
        filter: false
      },
      {
        headerName: 'Number of Forms',
        field: 'numberOfForms',
        cellClass: 'center-aligned',
        cellRendererFramework: NumberCellRenderer,
        minWidth: 100,
        width: 150,
        filter: 'agNumberColumnFilter',
        filterParams: { apply: true }
      },
      {
        headerName: '% Forms Valid',
        field: 'percentageOfValidForms',
        cellClass: 'center-aligned',
        valueGetter: ({
          data: { percentageOfValidForms }
        }) => (percentageOfValidForms !== 'NaN' ? percentageOfValidForms : 'N/A'),
        cellRendererFramework: NumberCellRenderer,
        minWidth: 100,
        width: 150,
        filter: 'agNumberColumnFilter',
        filterParams: { apply: true }
      },
      {
        headerName: 'Number of Form Pages',
        field: 'numberOfFormPages',
        cellClass: 'center-aligned',
        cellRendererFramework: NumberCellRenderer,
        minWidth: 100,
        width: 150,
        filter: 'agNumberColumnFilter',
        filterParams: { apply: true }
      },
      {
        headerName: 'Number of Pages',
        field: 'numberOfPages',
        cellClass: 'center-aligned',
        cellRendererFramework: NumberCellRenderer,
        minWidth: 100,
        width: 150,
        filter: 'agNumberColumnFilter',
        filterParams: { apply: true }
      },
      {
        headerName: 'Number of Files',
        field: 'numberOfFiles',
        cellClass: 'center-aligned',
        cellRendererFramework: NumberCellRenderer,
        minWidth: 100,
        width: 150,
        filter: 'agNumberColumnFilter',
        filterParams: { apply: true }
      },
      {
        headerName: 'View / Action',
        cellClass: 'center-aligned form-action-btns',
        field: 'id',
        cellRendererFramework: BatchActionsCellRenderer,
        minWidth: 70,
        width: 135,
        filter: false
      }
    ];

    return columnDefs;
  }
}
